var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"com-attachment"},[_c('img',{staticClass:"img",attrs:{"src":_vm.iconUrl}}),_c('a',{staticClass:"name document-text",attrs:{"href":_vm.fileUrl}},[_vm._v(_vm._s(_vm.fileName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }